<template>
    <div v-if="modalAlert" class="alert-modal toggle-alert">
        <div class="alert-modal-container">
            <div class="modal-content">
                <div id="alert-modal" class="card bg-orange-gradLight">

                    <button class="btn-close" @click="onCancel">
                        <img :src="close" alt="close">
                    </button>

                    <div class="card-body">
                        <div class="mensages-container">
                            <img :src="warning" alt="warning" class="message-img">
                            <h1>Tens a certeza que pretendes concluir a acção?</h1>
                            <p>Se alterares o tipo de serviço os produtos adicionados ao carrinho serão
                                removidos.</p>

                            <div class="modal-bottom double">
                                <div class="text-center">
                                    <button class="recover text-orange" @click="onCancel"><strong>Cancelar</strong>
                                    </button>
                                </div>
                                <div class="text-center">
                                    <button class="btn-bg" @click="onConfirm">Confirmar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import icClose from '../../svg/ic_close_orange.svg'
import icWarning from '../../svg/ic_warning.svg'

export default {
    data() {
        return {
            close: icClose,
            warning: icWarning,
            modalAlert: false,
        }
    },
    methods: {
        modalAlertHandler() {
            this.modalAlert = !this.modalAlert;

            document.querySelector('html').classList.toggle('no-scroll');
            document.querySelector('body').classList.toggle('no-scroll');
        },
        onConfirm() {
            Livewire.emit('onAboutUsConfirmDestroyCartAndChangeDeliveryMethod');
            this.modalAlertHandler();
        },
        onCancel() {
            this.modalAlertHandler();
        }
    },
    created() {
        Livewire.on('aboutUsConfirmDestroyCart', () => this.modalAlertHandler());
    }
}
</script>

<style>

</style>
